import { Autocomplete } from "@mui/material";
import { Axios } from "api/axios";
import BootstrapTextField from "Common/BootstrapTextField";
import SubmitButton from "Components/Buttons/SubmitButton";
import { City, Country, State } from "country-state-city";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import "react-country-state-city/dist/react-country-state-city.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddOrganisation = () => {
  const location = useLocation();
  const org = location.state?.org;
  const { id } = useParams<{ id: string }>();
  const [countries, setCountries] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const [formData, setFormData] = useState({
    organization_name: "",
    org_address: "",
    industry_type: "",
    org_city: "",
    org_state: "",
    org_country: "",
    org_pincode: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const commonInputStyle = {
    fontSize: "0.8rem",
    minHeight: 38,
    padding: "0.375rem 0.75rem",
  };
  const commonLabelStyle = {
    fontSize: "0.8rem",
    marginBottom: 6,
    marginTop: 12,
  };
  const containerStyle = {
    marginTop: "2rem",
    marginLeft: 0,
    marginRight: 0,
    padding: "2rem 1rem",
    //maxWidth: 1200,
    width: "100%",
    borderRadius: "0.75rem",
  };
  const cardStyle = { padding: "2rem 1rem", borderRadius: "0.75rem" };

  const dropdownStyle = {
    border: "none",
    outline: "none",
    borderRadius: "4px",
    minHeight: "30px",
    fontSize: "0.95rem",
    background: "#fff",
    boxShadow: "none",
    padding: "0 8px",
    width: "100%",
  };

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [stateLoading, setStateLoading] = useState(false);
  const [pincodeOptions, setPincodeOptions] = useState<string[]>([]);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [industryOptions, setIndustryOptions] = useState<string[]>([]);
  const [industryLoading, setIndustryLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedCountryId, setSelectedCountryId] = useState<any>("");
  const [selectedStateId, setSelectedStateId] = useState<any>("");
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [toastState, setToastState] = useState(true);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear field error on change
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  const requiredLabel = (label: string) => (
    <>
      {label} <span style={{ color: "red" }}>*</span>
    </>
  );

  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.organization_name.trim())
      newErrors.organization_name = "Organisation Name is required";
    if (!formData.org_address.trim())
      newErrors.org_address = "Address is required";
    if (!formData.industry_type.trim())
      newErrors.industry_type = "Industry is required";
    if (formData.org_city.trim() === "")
      newErrors.org_city = "City is required";
    if (formData.org_state.trim() === "")
      newErrors.org_state = "State is required";
    if (formData.org_country.trim() === "")
      newErrors.org_country = "Country is required";
    if (!formData?.org_pincode) newErrors.org_pincode = "Pincode is required";
    else if (!/^\d{5,6}$/.test(formData?.org_pincode))
      newErrors.org_pincode = "Pincode must 6 digits";
    return newErrors;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      if (toastState)
        toast.error("Please enter all required fields correctly.");
      setErrors(validationErrors);
      setToastState(false);
      return;
    }

    try {
      setIsSubmitting(true);
      // Map frontend state to backend expected payload
      const payload = {
        organization_name: formData.organization_name,
        org_address: formData.org_address,
        industry_type: formData.industry_type,
        org_city: formData.org_city,
        org_state: formData.org_state,
        org_country: formData.org_country,
        org_pincode: formData.org_pincode,
      };

      let response;
      if (id) {
        response = await Axios.put(`api/organization/edit/${id}/`, payload);
        console.log(response, "respose-----22");
      } else {
        response = await Axios.post("api/organization/create/", payload);
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(
          `Organisation ${id ? "updated" : "created"} successfully`
        );
        setTimeout(() => {
          window.history.length > 1
            ? navigate(-1)
            : navigate("/organisations-list");
        }, 1000);
      }
    } catch (error: any) {
      const backendErrors = error?.response?.data?.errors;
      const backendMessage = error?.response?.data?.message;

      console.log(backendErrors, "backendErrors");

      if (backendErrors) {
        if (typeof backendErrors === "string") {
          // handle string error
          toast.error(backendErrors);
        } else if (typeof backendErrors === "object") {
          // handle object error
          Object.entries(backendErrors).forEach(([field, messages]: any) => {
            if (Array.isArray(messages) && messages.length > 0) {
              const fieldName = field.replace(/_/g, " "); // optional formatting
              toast.error(`${fieldName}: ${messages[0]}`);
            }
          });
        }
      } else if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("Failed to save organisation");
      }
    } finally {
      setIsSubmitting(false);
    }


  };

  const handleCancelButton = () => {
    setFormData({
      organization_name: "",
      org_address: "",
      industry_type: "IT Services",
      org_city: "",
      org_state: "",
      org_country: "",
      org_pincode: "",
    });
    setErrors({});
    window.history.length > 1 ? navigate(-1) : navigate("/organisations-list");
  };

  useEffect(() => {
    const countryList = Country.getAllCountries();
    // console.log("countryli: ", countryList);
    setCountries(countryList);
  }, []);

  useEffect(() => {
    if (id && org) {
      const allCountries = Country.getAllCountries();
      const selectedCountry = allCountries.find(
        (c) => c.name === org.org_country
      );
      const countryIsoCode = selectedCountry?.isoCode || "";

      const statesOfCountry = State.getStatesOfCountry(countryIsoCode);
      const selectedState = statesOfCountry.find(
        (s) => s.name === org.org_state
      );
      const stateIsoCode = selectedState?.isoCode || "";

      const citiesOfState = City.getCitiesOfState(countryIsoCode, stateIsoCode);

      setCountries(allCountries);
      setStates(statesOfCountry);
      setCities(citiesOfState);

      setFormData({
        organization_name: org.organization_name || "",
        org_address: org.org_address || "",
        industry_type: org.industry_type || "",
        org_city: org.org_city || "",
        org_state: org.org_state || "",
        org_country: org.org_country || "",
        org_pincode: org.org_pincode || "",
      });
    }
  }, [id, org]);

  const safeIndustryOptions = useMemo(() => {
    if (
      formData.industry_type &&
      !industryOptions.includes(formData.industry_type)
    ) {
      return [formData.industry_type, ...industryOptions];
    }
    return industryOptions;
  }, [formData.industry_type, industryOptions]);

  return (
    <div
      className="add-organisation-container p-4 rounded shadow-sm bg-white fs-6"
      style={{ marginTop: "6rem", marginLeft: "2rem", marginRight: "2rem" }}
    >
      {/* <ToastContainer />   */}

      {/* Header Row: Title on Left, Breadcrumb on Right */}
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
          {/* Left: Back arrow + Title */}
          <div className="d-flex align-items-center">
            <span
              className="me-2"
              style={{ fontSize: "1.25rem", cursor: "pointer" }}
              onClick={() => {
                if (window.history.length > 1) {
                  navigate(-1);
                } else {
                  navigate("/organisations-list");
                }
              }}
            >
              ←
            </span>
            <h5 className="mb-0 fw-bold">
              {/* {id ? 'Edit Organisation' : 'Add Organisation'} */}
              <Link
                to="/organisations-list"
                className="text-decoration-none text-dark "
              >
                {id ? "Edit Organisation" : "Add Organisation"}
              </Link>
            </h5>
          </div>

          {/* Right: Breadcrumb */}
          <div className="text-muted" style={{ fontSize: "0.9rem" }}>
            <Link
              to="/organisations-list"
              className="text-decoration-none text-muted"
            >
              Organisation
            </Link>{" "}
            &gt;{" "}
            <Link to="" className="text-decoration-none text-muted">
              {id ? "Edit Organisation" : "Add Organisation"}
            </Link>
          </div>
        </div>
      </div>

      {/* ======= Your Form (unchanged below) ======= */}

      <Form noValidate onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col xs={12} md={6}>
            <Form.Label className="fw-semibold">
              {requiredLabel("Organisation Name")}
            </Form.Label>
            <Form.Control
              name="organization_name"
              value={formData.organization_name}
              onChange={handleChange}
              isInvalid={!!errors.organization_name}
              placeholder="Enter Organisation Name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.organization_name}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} md={6}>
            <Form.Label className="fw-semibold">
              {requiredLabel("Industry Type")}
            </Form.Label>
            <Form.Control
              name="industry_type"
              value={formData.industry_type}
              onChange={handleChange}
              isInvalid={!!errors.industry_type}
              placeholder="Enter Organisation Name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.industry_type}
            </Form.Control.Feedback>
          </Col>

          {/* <Col xs={12} md={6}>
            <Form.Label className='fw-semibold'>
              {requiredLabel('Industry Type')}
            </Form.Label>
            <Autocomplete
              disablePortal
              options={safeIndustryOptions}
              value={formData.industry_type || ''}
              onChange={(e, value) =>
                setFormData(prev => ({ ...prev, industry_type: value || '' }))
              }
              loading={industryLoading}
              openOnFocus={false}
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder='Select Industry'
                  error={!!errors.industry_type}
                  helperText={errors.industry_type}
                  fullWidth
                  size='small'
                  autoComplete='off'
                />
              )}
            />
          </Col> */}
        </Row>

        <Row className="mb-3">
          <Col xs={12} md={6}>
            <Form.Label className="fw-semibold">
              {requiredLabel("Address")}
            </Form.Label>
            <InputGroup>
              <Form.Control
                name="org_address"
                value={formData.org_address}
                onChange={handleChange}
                isInvalid={!!errors.org_address}
                placeholder="Enter Address"
              />
              {/* <InputGroup.Text>
                <BsSearch />
              </InputGroup.Text> */}
              <Form.Control.Feedback type="invalid">
                {errors.org_address}
              </Form.Control.Feedback>
            </InputGroup>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={4} xs={12} className="mb-3">
            <Form.Label className="fw-semibold" style={commonLabelStyle}>
              Country <span className="text-danger">*</span>
            </Form.Label>
            <Autocomplete
              disablePortal
              options={countries}
              getOptionLabel={(option) => option.name}
              value={
                countries.find((c: any) => c.name === formData.org_country) ||
                null
              }
              onChange={(e, selectedCountry) => {
                setFormData((prev) => ({
                  ...prev,
                  org_country: selectedCountry?.name || "",
                  org_state: "",
                  org_city: "",
                }));

                // Clear errors for country, state, and city
                setErrors((prev) => {
                  const newErrors = { ...prev };
                  delete newErrors.org_country;
                  delete newErrors.org_state;
                  delete newErrors.org_city;
                  return newErrors;
                });

                if (selectedCountry) {
                  setIsLoadingStates(true);
                  const newStates = State.getStatesOfCountry(selectedCountry.isoCode);
                  setStates(newStates);
                  setCities([]);
                  setIsLoadingStates(false);
                }
              }}

              renderInput={(params) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select Country"
                  size="small"
                  error={!!errors.org_country}
                  helperText={errors.org_country}
                  fullWidth
                />
              )}
            />
          </Col>

          <Col md={4} xs={12} className="mb-3">
            <Form.Label className="fw-semibold" style={commonLabelStyle}>
              State <span className="text-danger">*</span>
            </Form.Label>
            <Autocomplete
              disablePortal
              options={states}
              getOptionLabel={(option) => option.name}
              loading={isLoadingStates}
              value={
                states.find((s: any) => s.name === formData.org_state) || null
              }
              onChange={(e, selectedState) => {
                setFormData((prev) => ({
                  ...prev,
                  org_state: selectedState?.name || "",
                  org_city: "",
                }));

                // Clear errors for state and city
                setErrors((prev) => {
                  const newErrors = { ...prev };
                  delete newErrors.org_state;
                  delete newErrors.org_city;
                  return newErrors;
                });

                const selectedCountry = countries.find(
                  (c: any) => c.name === formData.org_country
                );

                if (selectedCountry && selectedState) {
                  setIsLoadingCities(true);
                  const newCities = City.getCitiesOfState(
                    selectedCountry.isoCode,
                    selectedState.isoCode
                  );
                  setCities(newCities);
                  setIsLoadingCities(false);
                }
              }}

              renderInput={(params) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select State"
                  size="small"
                  error={!!errors.org_state}
                  helperText={errors.org_state}
                  fullWidth
                />
              )}
              disabled={!formData.org_country}
            />
          </Col>

          <Col md={4} xs={12} className="mb-3">
            <Form.Label className="fw-semibold" style={commonLabelStyle}>
              City <span className="text-danger">*</span>
            </Form.Label>
            <Autocomplete
              disablePortal
              options={cities}
              getOptionLabel={(option) => option.name}
              loading={isLoadingCities}
              value={
                cities.find((c: any) => c.name === formData.org_city) || null
              }
              onChange={(e, selectedCity) => {
                setFormData((prev) => ({
                  ...prev,
                  org_city: selectedCity?.name || "",
                }));

                // Clear error for city
                setErrors((prev) => {
                  const newErrors = { ...prev };
                  delete newErrors.org_city;
                  return newErrors;
                });
              }}

              renderInput={(params) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select City"
                  size="small"
                  error={!!errors.org_city}
                  helperText={errors.org_city}
                  fullWidth
                />
              )}
              disabled={!formData.org_state}
            />
          </Col>
          <Col md={4} xs={12} className="mb-4 mb-md-0">
            <Form.Label className="fw-semibold" style={commonLabelStyle}>
              Pincode <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              name="org_pincode"
              placeholder="Enter Pincode"
              value={formData.org_pincode}
              onChange={handleChange}
              isInvalid={!!errors.org_pincode}
              size="sm"
              style={commonInputStyle}
            />
            <Form.Control.Feedback type="invalid">
              {errors.org_pincode}
            </Form.Control.Feedback>
          </Col>
        </Row>

        {/* Buttons */}
        <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
          <Button
            variant="outline-secondary"
            style={{
              color: "#878899",
              borderColor: "#B0BAC9",
              backgroundColor: "transparent",
            }}
            type="reset"
            onClick={handleCancelButton}
          >
            Cancel
          </Button>

          {/* Reusable submit button with spinner */}
          <SubmitButton
            isSubmitting={isSubmitting} // or any loading state you use
            isEdit={!!id} // true if editing
            labels={{
              create: "Submit", // instead of "Add"
              update: "Update", // instead of "Update"
              submitting: "Submitting...", // while creating
              updating: "Saving...", // while editing
            }}
          />
        </div>
      </Form>
    </div>
  );
};

export default AddOrganisation;
